import { render, staticRenderFns } from "./product-carousel.vue?vue&type=template&id=04ebc0fb&scoped=true&"
import script from "./product-carousel.vue?vue&type=script&lang=js&"
export * from "./product-carousel.vue?vue&type=script&lang=js&"
import style0 from "./product-carousel.vue?vue&type=style&index=0&id=04ebc0fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebc0fb",
  null
  
)

export default component.exports